import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { hasViewMenuDeveloper } from 'selectors/permissions';
import lazyLoad from 'utils/lazyLoad';
import { getRouterPath } from 'utils/navigation';
import { UnauthorizedPageAccess } from './utils';

const SignalsReport = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "SignalsReport" */ 'pages/Reports/SignalsReport'
    ),
);

const SignalSuppressionReport = lazyLoad(
  () =>
    import(
      /* webpackChunkName: "SignalSuppressionReport" */ 'pages/Reports/SignalSuppressionReport'
    ),
);

export default function useSignalsReportRoutes() {
  const canViewSignalsReport = useSelector(hasViewMenuDeveloper);
  return [
    <Route
      path={getRouterPath('/reports/signals/')}
      component={canViewSignalsReport ? SignalsReport : UnauthorizedPageAccess}
    />,
    <Route
      path={getRouterPath(
        '/reports/signalSuppression/:signalUuid/:triggerName',
      )}
      component={
        canViewSignalsReport ? SignalSuppressionReport : UnauthorizedPageAccess
      }
    />,
  ];
}
